import { cacheTypes, getMethodByCallBack, postMethod, postMethodByCallBack } from "../../../store/api/CommonFunctions";

export function getAll(parentID, onGet) {
    getMethodByCallBack(`api/EventCategories/GetAll?parentID=${parentID ?? ""}`, cacheTypes.NoCache, onGet, "GetAll");
}
export async function  create(data) {
   const result= await postMethod("api/EventCategories/Create", data, "CREATE_EV_CAT");
   return result;
}
export function update(data, onUpdate) {
    postMethodByCallBack("api/EventCategories/Update", data, onUpdate, "UPDATE_EV_CAT");
}
export function deleteCategory(id, onDelete) {
    getMethodByCallBack(`api/EventCategories/Delete?id=${id}`, cacheTypes.NoCache, onDelete, "DEL_EV_CAT");
}